export function setCookie(cname, cvalue, hours) {
    let d = new Date();
    d.setTime(d.getTime() + (hours * 60 * 60 * 1000)); // (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) ===' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
}

export function hasUser() {
    let user = getCookie('id');
    let session =  localStorage.getItem('user');
    return user !== '' && session;
}

export function removeCookie(cookie_name){
    if( getCookie( cookie_name ) ) {
        document.cookie = cookie_name + "=" +
            ";path=/" +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
